import { render, staticRenderFns } from "./CourseTop.vue?vue&type=template&id=336a403b&scoped=true"
import script from "./CourseTop.vue?vue&type=script&lang=js"
export * from "./CourseTop.vue?vue&type=script&lang=js"
import style0 from "./CourseTop.vue?vue&type=style&index=0&id=336a403b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336a403b",
  null
  
)

export default component.exports